import { configureStore } from "@reduxjs/toolkit";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { createLogger } from "redux-logger";
import { thunk } from "redux-thunk";
import appReducers from "./reducers/Reducers";

const configureEnvStore = (initialState) => {
    let middlewares = [thunk];

    if (process.env.NODE_ENV !== "production") {
        const loggerMiddleware = createLogger({
            level: "info",
            collapsed: true,
            predicate: (_, action) => !(action.type.includes("setCallDuration") || action.type.includes("setWaitingBarWidth")),
        });

        middlewares = [...middlewares, loggerMiddleware, reduxImmutableStateInvariant()];
    }

    const store = configureStore({
        reducer: appReducers,
        middleware: () => middlewares,
        devTools: process.env.NODE_ENV !== "production",
        preloadedState: initialState,
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers([]),
    });

    return store;
};

const reduxStore = configureEnvStore();

export default reduxStore;
